import React, { useState, useEffect, useRef }       from 'react';
import MedicalCertificateService                    from 'services/medical-certificate.service';
import AuthService                                  from 'services/auth.service';
import { Form, Modal, Button }                      from "react-bootstrap";
import MedicalCertificateSubmitConfirmModal         from "./MedicalCertificateSubmitConfirmModal";
import MedicalCertificateDetails                    from "./MedicalCertificateDetails";
import moment                                       from 'moment';
import DayPickerInput                               from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate }                    from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

function MedicalCertificate({chat}) {
  const defaultMc = {
    "video_session_id": null,
    "start_date": '',
    "end_date": '',
  }
  const isMedicalCertificateCancelled = useRef(false);
  const isCertifiedCancelled = useRef(false);
  const isDateCancelled = useRef(false);
  const [certified, setCertified] = useState(chat?.e_mc?.medical_certificate_id); 
  const [noMedicalCertificate, setNoMedicalCertificate] = useState(!chat.e_mc.enabled);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [mc, setMc] = useState([defaultMc]);
  const [showMcConfirm, setShowMcConfirm] = useState(false);
  const [emc, setEmc] = useState({});
  const [from, setFrom] = useState(undefined);
  const [to, setTo] = useState(undefined);
  const [days, setDays] = useState(0);
  const modifiers = { start: from, end: to };

  const MedicalCertificateConfirmationModal = () => {
    return (
      <Modal show={showConfirmation} onHide={() => {setShowConfirmation(false)}} backdrop="static" keyboard={false}>
        <Modal.Body>
          By checking <b>"No medical certificate needed for this consultation"</b>, you are indicating that medical certificate is not required for this consultation. Do note that this action is irreversible. Please confirm.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {setShowConfirmation(false)}}>Cancel</Button>
          <Button variant="danger" onClick={confirmNoMedicalCertificate}>Yes, Confirm</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  useEffect(() => {
    if(!certified){
      const params = {
        e_mc: !noMedicalCertificate
      }
      MedicalCertificateService.toggleMc(chat.id, params).then(
        (data) => {
          // after mc required updated
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
    return () => {
      isMedicalCertificateCancelled.current = true;
    };
  }, [noMedicalCertificate]); // eslint-disable-line

  useEffect(() => {
    if(certified){
      MedicalCertificateService.getMedicalCertificate(certified).then(
        (data) => {
          setEmc(data);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
    return () => {
        isCertifiedCancelled.current = true;
    };
  }, [certified]); // eslint-disable-line

  useEffect(() => {
    if(from && to){
      setMc({
        video_session_id: chat?.video_session?.id,
        start_date: from,
        end_date: to,
      })
      setDays(getDaysDiff(from, to));
    }else{
      setDays(0);
    }
    return () => {
        isDateCancelled.current = true;
    };
  }, [from, to]); // eslint-disable-line

  const confirmNoMedicalCertificate = () => {
    setNoMedicalCertificate(true);
    setShowConfirmation(false);
  }  

  const handleSetNoMc = (e) => {
    if(e.target.checked){
      setShowConfirmation(true);
    }else{
      setNoMedicalCertificate(false);
    }
  }

  // medical certificate
  const medicalCert = () => {
    var isTo = '';
    const showFromMonth = () => {
      if (!from) {
        return;
      }
    }
    const handleFromChange = (from) => {
      // Change the from date and focus the "to" input field
      setFrom(from);
    }
  
    const handleToChange = (to) => {
      setTo(to);
      showFromMonth();
    }

    return (
      <div className="d-flex mc-row">
        <div className="col-12 col-lg-10 mc-date-range">
          <div className="w-100">
            <label className="mc-field-label">Date</label>
            <div>
              <DayPickerInput
                value={from}
                placeholder="From"
                format="LL"
                formatDate={formatDate}
                parseDate={parseDate}
                dayPickerProps={{
                  selectedDays: [from, { from, to }],
                  disabledDays: { after: to, before: new Date() },
                  toMonth: to,
                  modifiers,
                  numberOfMonths: 1,
                  onDayClick: () => isTo.getInput().focus(),
                }}
                onDayChange={handleFromChange}
              />
              <DayPickerInput
                ref={el => (isTo = el)}
                placeholder="To"
                format="LL"
                formatDate={formatDate}
                parseDate={parseDate}
                dayPickerProps={{
                  selectedDays: [from, { from, to }],
                  disabledDays: { before: from ? from : new Date() },
                  modifiers,
                  month: from,
                  fromMonth: from,
                  numberOfMonths: 1,
                }}
                onDayChange={handleToChange}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-2 px-1 text-nowrap text-center">
          <div className="w-100">
            <label className="mc-field-label">Day</label>
            <div className="days-value">{days}</div>
          </div>
        </div>
      </div>
    );
  }

  const getDaysDiff = (startDate, endDate) => {
    var dateFrom = moment(startDate);
    var dateTo = moment(endDate);
    var dayDiff = dateTo.diff(dateFrom, 'days');
    return dayDiff+1;
  }

  // mc confirmation
  const mcConfirm = () => {
    if(to && from){
      setShowMcConfirm(true);
    }else{
      alert("Please select the date before submitting.");
    }
  }

  return (
    <div className="medical-certificate">
      <h6 className="p-2">Electronic Medical Certificate (e-MC)</h6>
      {certified ? <MedicalCertificateDetails emc={emc} getDaysDiff={getDaysDiff}/> : (
        <>
          <Form.Check inline>
            <Form.Check.Input 
              id="medicalCertificate" 
              type="checkbox" 
              checked={noMedicalCertificate}
              onChange={(e) => {handleSetNoMc(e)}} />
            <Form.Check.Label htmlFor="medicalCertificate">No medical certificate needed for this consultation</Form.Check.Label>
          </Form.Check>
          {!noMedicalCertificate && 
            <>
              {medicalCert()}
              <div className="d-flex justify-content-end mt-8">
                <div><button className="btn save-mc-btn" onClick={() => mcConfirm()}>Submit e-MC</button></div>
              </div>
            </>
          }
          <MedicalCertificateConfirmationModal />
          <MedicalCertificateSubmitConfirmModal setShowMcConfirm={setShowMcConfirm} showMcConfirm={showMcConfirm} mc={mc} getDaysDiff={getDaysDiff} setCertified={setCertified}/>
        </>
      )}
    </div>
  )
}

export default MedicalCertificate;